import {Inject, Injectable, Injector} from '@angular/core';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    loaderService: Subject<{ show: boolean }> = new Subject<{ show: boolean }>();

    constructor() {
    }

    public presentLoading() {
        this.loaderService.next({show: true});
    }

    public dismissLoading() {
        this.loaderService.next({show: false});
    }
}
